export default __webpack_public_path__ + "static/media/brainy.689275e4.png";